<template>
  <div :class="{noPc: !isPc}">
    商務用途不包稅：<br>
    1、商務用途主動申報（簡易報關X3、正式報關）<br>
    2、應是商務用途需要報關的貨物以個人進口，但被海關C3查驗要求申報繳稅的情況
    <!-- 海關要求轉正式報關<br>
    單件超70KG轉正式報關<br>
    您主動要求繳稅報關<br>
    個別商品數量或重量明顯超出個人用途範疇（詳情請使用【<span v-if="isPc">能寄嗎</span><router-link
      v-else
      :to="{name: 'KkrenParcelCanPack'}">能寄嗎</router-link>】查詢） -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      isPc: window.isPc
    }
  },
}
</script>
<style lang="postcss" scoped>
.noPc {
  font-size: 20px;
  line-height: 1.2em;
}
</style>
